import { axiosInstance } from '@/http-common'

export async function getWirepasLocations(): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/wirepas-locations')
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasLocation(id: number | string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`/api/v1/wirepas-locations/${id}`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasAssetDetail(id: number | string, hours = 24): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`/api/v1/wirepas-assets/${id}/detail`, { params: { hours } })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasAssetsStats(): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/wirepas-assets/stats')
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasAssets(params?: Record<string, any>): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/wirepas-assets', { params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasLocationDetail(id: number | string, hours = 24): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`/api/v1/wirepas-locations/${id}/detail`, { params: { hours } })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasGateways(): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/wirepas-locations/gateways')
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasGatewaysAdmin(params?: { skip?: number; take?: number; searchValue?: string; onlyOffline?: boolean }): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/admin/wirepas-gateways', { params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasGatewaysStats(): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/admin/wirepas-gateways/stats')
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasAnchors(params?: { skip?: number; take?: number; searchValue?: string; gwId?: string; onlyOffline?: boolean; includeTagsHeard?: boolean }): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/admin/wirepas-anchors', { params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasAnchorsStats(): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/admin/wirepas-anchors/stats')
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasFleetHealth(params?: { skip?: number; take?: number; searchValue?: string }): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/wirepas-assets/fleet-health', { params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasFleetHealthStats(): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/wirepas-assets/fleet-health/stats')
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasTopology(gwId: string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`/api/v1/admin/wirepas-topology/${encodeURIComponent(gwId)}`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasConsoleMessages(limit = 200): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/admin/wirepas-console/messages', { params: { limit } })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasConsoleNodes(): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/admin/wirepas-console/nodes')
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasConsoleGateways(): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/admin/wirepas-console/gateways')
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function getWirepasConsoleCadence(windowSec: number, addr?: string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/admin/wirepas-console/cadence', { params: { windowSec, addr: addr || undefined } })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}
